import _ from 'lodash';
import { createClient } from '@/shared/api';
import type { ReportQuery, ReportQueryVariables } from '@/shared/api';
import REPORT_QUERY from '../queries/report';

/**
 * Loads a single study report by id. Creates an Apollo client, runs the report query, and throws the first GraphQL error message when the report came back nil alongside errors.
 *
 * @param id - Identifier of the report to load.
 * @returns Promise resolving to the report record.
 */
const fetchReport = async (id: any) => {
  const client = createClient();
  const reportResult = await client.query<ReportQuery, ReportQueryVariables>({
    query: REPORT_QUERY,
    variables: {
      id,
    },
  });
  const { data, errors } = reportResult;
  const { report } = data;
  if (_.isNil(report) && errors?.length) {
    throw new Error(errors[0].message);
  }
  return report;
};

export default fetchReport;
